module.exports = __webpack_public_path__ + "img/sign-9.33c8841d.jpg";